<template>
  <div id="page">
    <div class="block-wrapper">
      <h3 class="block-heading mb2">Donate</h3>
      <p>
        Forensis is a non-profit research agency dedicated to investigating
        human rights violations, and state and corporate violence. Our
        award-winning work is made possible through the generous support of
        foundations and donors. Help us continue this vital work and stand with
        communities in their pursuit of justice, truth, and accountability.
      </p>
      <div
        style="
          display: flex;
          justify-content: center;
          width: 100%;
          margin-top: 2em;
        "
      >
        <div
          id="betterplace_donation_iframe"
          style="
            background: transparent
              url('https://www.betterplace.org/assets/new_spinner.gif')
              275px 20px no-repeat;
            max-width: 600px;
            min-width: 250px;
            width: 100%;
          "
        >
          <strong>
            
              href="https://www.betterplace.org/en/donate/platform/projects/181890-donate-to-independent-investigative-work"
            >
              Donate now for "Donate to independent investigative work".
              The donation is processed by our partner
              <a href="http://betterplace.org">betterplace.org</a>
            </a>
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const BP_SCRIPT_SRC =
  "https://betterplace-assets.betterplace.org/assets/load_donation_iframe.js";

// Fallback markup restored on unmount so a remount reinitializes cleanly
const BP_FALLBACK_HTML = `
  <strong>
    <a href="https://www.betterplace.org/en/donate/platform/projects/181890-donate-to-independent-investigative-work">
      Donate now for "Donate to independent investigative work".
      The donation is processed by our partner
      <a href="http://betterplace.org">betterplace.org</a>
    </a>
  </strong>
`;

export default {
  name: "Donate",
  mounted() {
    // Configure the embed — must exist before the loader script runs
    window._bp_iframe = window._bp_iframe || {};
    window._bp_iframe.project_id = 181890; // REQUIRED
    window._bp_iframe.lang = "en";
    window._bp_iframe.width = 600;
    window._bp_iframe.color = "003060";
    window._bp_iframe.background_color = "ffffff";
    window._bp_iframe.default_amount = 50;
    window._bp_iframe.recurring_interval = "single"; // single | monthly | yearly
    window._bp_iframe.bottom_logo = true;

    if (!document.querySelector(`script[src="${BP_SCRIPT_SRC}"]`)) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = BP_SCRIPT_SRC;
      document.head.appendChild(script);
    }
  },
  beforeDestroy() {
    // Vue 3: rename this to beforeUnmount()
    const script = document.querySelector(`script[src="${BP_SCRIPT_SRC}"]`);
    if (script) {
      script.remove();
    }

    // Reset the target div and global config so a remount works correctly
    const container = document.getElementById("betterplace_donation_iframe");
    if (container) {
      container.innerHTML = BP_FALLBACK_HTML;
    }
    delete window._bp_iframe;
  },
};
</script>